import React, { Fragment } from "react";
import { fmtCurrency, isCardType } from "../helpers";
import CardTypes from "./CardTypes";
import Input from "../components/Input";

const CreditPayment = ({ update, data, errors }) => {
  return (
    <Fragment>
      <CardTypes type={isCardType(data.number || "")} />

      <div className="form-group">
        <Input
          name="number"
          label="Credit or Debit Card Number"
          reqd={true}
          value={data.number || ""}
          update={update}
          errors={errors}
          autocomplete="cc-number"
        />

        <Input
          name="cardholder"
          label="Cardholder Name"
          reqd={true}
          value={data.cardholder || ""}
          update={update}
          errors={errors}
          autocomplete="off"
        />
      </div>

      <div className="form-group">
        <Input
          name="expdate"
          label="Expiration Date (mm/yyyy)"
          reqd={true}
          value={data.expdate || ""}
          update={update}
          errors={errors}
          placeholder="mm/yyyy"
          autocomplete="cc-exp"
        />

        <Input
          name="code"
          label="CSC/CVV Code"
          reqd={true}
          value={data.code || ""}
          update={update}
          errors={errors}
          autocomplete="cc-csc"
        />
      </div>

      {data.amt > 0 && (
        <div className="terms">
          <p className="bold" style={{ fontSize: "1.1rem" }}>
            Verify your payment details and click submit, your card will be
            charged {fmtCurrency(data.amt / 100)}.
          </p>
          <p>
            <span>
              All credit card charges will show up under the title of{" "}
              <span className="bold">Valero Energy Foundation</span> (dba
              Champions <i>fore</i> Charity) on your credit card statement.
              Clicking submit, your donation commitment amount will be processed
              and your card will be charged. All transactions are final and 100%
              of your donation will go to {data.charity}.
            </span>
          </p>
        </div>
      )}
    </Fragment>
  );
};

export default CreditPayment;
